module.exports = __webpack_public_path__ + "img/createMap.1dda71a5.svg";